export default __webpack_public_path__ + "static/un-43684c45920d8e50ef532c00b287b960.svg";